import React, {useState} from 'react';
import {Grid, Box, Typography} from '@mui/material';
import {useNavigate} from "react-router-dom";

import FormTextInput from "../../components/FormTextInput";
import FormButton from "../../components/FormButton";
import AlertMsg from "../../components/AlertMsg";

import {connect} from "react-redux";
import {loginAdmin} from "../../redux/actions/userDataActions";

import EyeIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import EyeOffIcon from '@mui/icons-material/VisibilityOffOutlined';
// import {ReactComponent as Checkbox} from "../../assets/img/checkbox.svg";
// import {ReactComponent as UnCheckbox} from "../../assets/img/uncheckbox.svg";
import {ReactComponent as LogoIcon} from "../../assets/img/logo.svg";

import AuthRightBottomImg from '../../assets/img/auth_right_bottom.png';
import AuthTopLeftImg from '../../assets/img/auth_top_left.png';

import styles from "./Login.module.css"

const Login = (props) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordEyeVisible, setPasswordEyeVisible] = useState(false);
  const [error, setError] = useState(null);
  const [checked, setChecked] = useState(false);

  const navigate = useNavigate();

  const onSignIn = () => {
    let errorText = {};
    if (userName == '') {
      errorText = {userName: 'Please enter email / username'};
    }
    if (password == '') {
      errorText = {...errorText, password: 'Please enter your password'};
    }

    if (Object.keys(errorText).length != 0) {
      setError(errorText);
      return;
    }

    let data = {
      username: userName,
      password: password
    };
    props.loginAdmin(JSON.stringify(data))

  };

  const onPasswordEyeIconClick = () => {
    if (passwordEyeVisible) {
      setPasswordEyeVisible(false)
    } else {
      setPasswordEyeVisible(true)
    }
  };

  const onChange = (val, type) => {
    let errorText = error;
    if (type == 'username') {
      errorText = {...error, userName: ''};
      setUserName(val)
    } else if (type == 'password') {
      errorText = {...error, password: ''};
      setPassword(val)
    }
    setError(errorText);
  };

  const onRegisterClick = () => {
    navigate("/register");
  };

  return (
    <Grid container item md={12} xs={12} display={"flex"} flexDirection={"row"}
          alignItems={"center"} justifyContent={"center"} className={styles.cardMainView}>


      <Grid item md={2} xs={12}>
        <Box className={styles.boxLeftView}>
          <img alt="" src={AuthTopLeftImg} className={styles.imgStyle}/>
        </Box>
      </Grid>


      <Grid item md={8} xs={12} display={"flex"} alignItems={"center"} justifyContent={"center"}>
        <Grid className={styles.cardView} sx={{
          minHeight: window.innerHeight - 220,
          width: {md: '40%', sm: '85%', xs: '85%'}
        }}>
          <Box className={styles.logoView}>
            <LogoIcon height={80}/>
          </Box>
          <Typography className={styles.subTitleText} mt={1}>Welcome to Celesta! 👋</Typography>
          <Typography className={styles.contentText} mt={1}>Please sign-in to your account and start the
            adventure</Typography>

          <Grid container item md={12} xs={12} mt={4}>
            <FormTextInput
              page={'Login'}
              error={error?.userName}
              value={userName}
              setValue={(val) => onChange(val, 'username')}
              label={'EMAIL OR USERNAME'}
              placeholder={'Enter your email or username'}
            />
          </Grid>

          <Grid container item md={12} xs={12} mt={2.5}>

            <Grid item md={12} xs={12} className={styles.passwordForgotView}>
              <Typography className={styles.passwordLabelText}>PASSWORD</Typography>
              <Typography className={styles.forgotPasswordText}>Forgot Password?</Typography>
            </Grid>

            <FormTextInput
              page={'Login'}
              error={error?.password}
              value={password}
              setValue={(val) => onChange(val, 'password')}
              placeholder={'..........'}
              type={passwordEyeVisible ? 'text' : 'password'}
              icon={true}
              rightIcon={passwordEyeVisible ? <EyeIcon sx={style.eyeIconStyle}/> : <EyeOffIcon sx={style.eyeIconStyle}/>}
              onIconClick={onPasswordEyeIconClick}
            />
          </Grid>

          {/*<Box*/}
          {/*  className={styles.rememberView}*/}
          {/*  onClick={() => setChecked(!checked)}*/}
          {/*  display={"flex"} flexDirection={"row"}*/}
          {/*  alignItems={"center"}*/}
          {/*  mt={2}>*/}
          {/*  {checked ?*/}
          {/*    <Checkbox height={20} width={20}/> :*/}
          {/*    <UnCheckbox height={20} width={20}/>}*/}
          {/*  <Typography className={styles.rememberText} ml={0.5}>Remember Me</Typography>*/}
          {/*</Box>*/}

          <Grid container
                item md={12} xs={12}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                mt={4}>
            <FormButton
              loading={props.loginBtnLoading}
              title={'Sign in'}
              btnStyleView={style.btnStyleView}
              onSubmit={onSignIn}
            />
          </Grid>

          {/*<Grid className={styles.accountMainView}>*/}
            {/*<Typography className={styles.platformText}>New on our platform?</Typography>*/}
            {/*<Box*/}
            {/*  onClick={() => onRegisterClick()}*/}
            {/*  className={styles.accountView}>*/}
            {/*  <Typography className={styles.accountText}>Create an account</Typography>*/}
            {/*</Box>*/}
          {/*</Grid>*/}
        </Grid>
      </Grid>

      <Grid item md={2} xs={12}>
        <Box className={styles.boxRightView}>
          <img alt="" src={AuthRightBottomImg} className={styles.imgStyle}/>
        </Box>
      </Grid>


      <AlertMsg/>

    </Grid>
  )
};

const mapStateToProps = (state) => {
  return {
    loginBtnLoading: state.userData.loginBtnLoading,
  };
};


const mapDispatchToProps = dispatch => {
  return {
    loginAdmin: data => dispatch(loginAdmin(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);

const style = {
  btnStyleView: {
    height: 40,
    width: '100%'
  },
  eyeIconStyle:{
    color: '#888',
    height: 15,
    width: 15
  }
}
